export const FEATURE_FLAGS = {
  ENABLE_AGENT_PLATFORM: 'enableAgentPlatform',
};
